<div class="wrap">
  <div class="content">
    <h2>Importer une nouvelle image principale</h2>

    <div class="upload_img">
      <div class="upload">
        <div class="input">
          <p class="size_max">Taille max. 300kB, privilégier format paysage 16/9</p>
          <input type="file" #fileDropRef id="fileDropRef" (change)="uploadImage($event.target.files)" />
        </div>

        <div>
          <div class="file_name" *ngIf="file">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
            {{ this.file?.name }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>
    <button (click)="confirm()" class="confirm" form="choiceClubForm" [disabled]="file === null"
      [style.opacity]="file === null? .5 : 1">Confirmer</button>
  </div>

</div>